import { isObject } from "./util";

export class SettingsManager {

   constructor(name, onChange) {
      this.name = name;
      this.data = {};
      this.clear();
      this.onChange = onChange;
   }

   clear() {
      this.data = {};
      this.links = {};
      this.lastUpdate = 0;
   }

   loadFromLocalStorage() {
      this.clear();
      try {
         this.load(JSON.parse(localStorage.getItem(this.name)));
      }
      catch (e) {
         console.error(e);
         this.clear();
      }
   }

   saveToLocalStorage() {
      localStorage.setItem(this.name, JSON.stringify({
         lastUpdate: this.lastUpdate,
         data: this.getData()
      }));
   }

   load(data) {
      let newData = Object.extend(true, { data: {}, lastUpdate: 0 }, data);
      this.lastUpdate = newData.lastUpdate;
      this.data = newData.data;
      if (!isObject(this.data)) this.data = {};
      this.saveToLocalStorage();
   }

   getData() {
      for (let name in this.links) {
         this.data[name] = this.links[name].obj[this.links[name]];
      }
      return this.data;
   }

   exportData() {
      return {
         lastUpdate: this.lastUpdate,
         data: JSON.stringify(this.getData())
      }
   }

   set(name, value, update=false) {
      this.data[name] = value;
      if (update) {
         this.lastUpdate = Math.floor(Date.now() / 1000);
         this.saveToLocalStorage();
         this.onChange();
      }
   }

   get(name, def) {
      if (this.data.hasOwnProperty(name) && this.data.name !== null) return this.data[name];
      else return def;
   }

   linkToObject(name, object, key) {
      this.links[name] = { obj: object, key: key };
   }

}

